<button type="button" class="theme-menu-trigger" [matMenuTriggerFor]="themeMenu" aria-label="Theme" title="Theme">
  <mat-icon aria-hidden="true">palette</mat-icon>
  <span class="theme-menu-label">Theme</span>
  <mat-icon class="theme-menu-chevron" aria-hidden="true">arrow_drop_down</mat-icon>
</button>

<mat-menu #themeMenu="matMenu" class="phms-theme-menu" xPosition="before">
  @for (mode of modes; track mode.name) {
    <button mat-menu-item role="menuitemradio" class="theme-menu-option"
      [attr.aria-checked]="savedTheme().themeVariantMode === mode.name"
      (click)="themeService.setThemeVariantByMode(mode.name)">
      <mat-icon aria-hidden="true">{{ mode.icon }}</mat-icon>
      <span>{{ mode.name }}</span>
      <span class="theme-menu-selection" [class.selected]="savedTheme().themeVariantMode === mode.name" aria-hidden="true">
        <mat-icon>check</mat-icon>
      </span>
    </button>
  }

  <div class="theme-menu-divider" role="separator"></div>

  @for (theme of themes; track theme.themeName) {
    <button mat-menu-item role="menuitemradio" class="theme-menu-option"
      [attr.aria-checked]="savedTheme().themeName === theme.themeName"
      (click)="themeService.loadThemeStyle(theme.themeName)">
      <span class="theme-menu-swatch" [style.background-color]="theme.backgroundColor" aria-hidden="true"></span>
      <span>{{ theme.themeName }}</span>
      <span class="theme-menu-selection" [class.selected]="savedTheme().themeName === theme.themeName" aria-hidden="true">
        <mat-icon>check</mat-icon>
      </span>
    </button>
  }
</mat-menu>
